/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#mobile-dictionary .dictionary{height:100%;width:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}  #mobile-dictionary .dictionary .description{-webkit-box-flex:0;flex:0}  #mobile-dictionary .dictionary .description p{padding:0;font-size:1rem;line-height:1.4rem}  #mobile-dictionary .dictionary .search-form-group input{width:100%;font-size:1rem}  #mobile-dictionary .dictionary .search-form-group button{font-size:1rem;padding:.6rem .7rem}  #mobile-dictionary .dictionary .dictionary-search-form{height:100%;-webkit-box-flex:1;flex:1}  #mobile-dictionary .dictionary .search-result{-webkit-box-flex:1;flex-grow:1;overflow-y:scroll;-webkit-overflow-scrolling:touch}"];
export { styles as styles };
//# sourceMappingURL=mobile-dictionary.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/mobile-dictionary/mobile-dictionary.component.scss.shim.ngstyle.js
// module id = 1373
// module chunks = 26 27 28